// Global configuration for API endpoints and environment detection
export const CONFIG = {
  // API Base URL Configuration
  API_BASE_URL: (() => {
    // 优先级: 环境变量 > 环境检测 > 默认值
    if (import.meta.env.VITE_API_BASE_URL) {
      return import.meta.env.VITE_API_BASE_URL;
    }
    
    // 检测部署环境
    const isVercel = typeof window !== 'undefined' && 
                     (window.location.hostname.includes('vercel.app') || 
                      window.location.hostname.includes('tectonix-procurement'));
    
    const isRender = typeof window !== 'undefined' && 
                     window.location.hostname.includes('onrender.com');
    
    const isLocalhost = typeof window !== 'undefined' && 
                        (window.location.hostname === 'localhost' || 
                         window.location.hostname === '127.0.0.1');
    
    // 检测本地开发端口
    const isLocalDev = isLocalhost && 
                      (window.location.port === '3005' || 
                       window.location.port === '3000' || 
                       window.location.port === '3001' || 
                       window.location.port === '3002' || 
                       window.location.port === '3003' || 
                       window.location.port === '3004');
    
    // 根据环境返回对应的API地址
    if (isVercel) {
      return 'https://api.procurement.tectonixai.com'; // Vercel前端 -> API后端
    } else if (isRender) {
      return 'https://api.procurement.tectonixai.com'; // Render前端 -> API后端
    } else if (isLocalDev) {
      return 'http://localhost:5001'; // 本地前端 -> 本地后端
    } else {
      // 生产环境默认使用Render
      return import.meta.env.PROD ? 'https://api.procurement.tectonixai.com' : 'http://localhost:5001';
    }
  })(),
  
  // Environment Detection
  IS_PRODUCTION: import.meta.env.PROD,
  IS_DEVELOPMENT: import.meta.env.DEV,
  IS_VERCEL_DEPLOYMENT: typeof window !== 'undefined' && 
                        (window.location.hostname.includes('vercel.app') || 
                         window.location.hostname.includes('tectonix-procurement')),
  IS_VERCEL_FEATURE_BRANCH: typeof window !== 'undefined' && 
                            (window.location.hostname.includes('vercel.app') && 
                             window.location.hostname.includes('-git-')),
  IS_RENDER_DEPLOYMENT: typeof window !== 'undefined' && 
                        window.location.hostname.includes('onrender.com'),
  IS_LOCALHOST: typeof window !== 'undefined' && 
                (window.location.hostname === 'localhost' || 
                 window.location.hostname === '127.0.0.1'),
  
  // Current Environment Info
  CURRENT_ORIGIN: typeof window !== 'undefined' ? window.location.origin : '',
  
  // Debug Mode and Level
  DEBUG_MODE: import.meta.env.DEV || import.meta.env.VITE_DEBUG === 'true',
  DEBUG_LEVEL: (() => {
    const level = import.meta.env.VITE_DEBUG_LEVEL || 'minimal';
    return ['none', 'minimal', 'normal', 'verbose'].includes(level) ? level : 'minimal';
  })()
};

// Console logging for configuration
if (CONFIG.DEBUG_MODE && CONFIG.DEBUG_LEVEL !== 'none') {
  console.log('🚀 Global API setup complete.');
  console.log('🎯 Primary URL:', CONFIG.API_BASE_URL);
  console.log('🌍 Current origin:', CONFIG.CURRENT_ORIGIN);
  console.log('🔧 Is Vercel deployment:', CONFIG.IS_VERCEL_DEPLOYMENT);
  console.log('🔧 Is Vercel feature branch:', CONFIG.IS_VERCEL_FEATURE_BRANCH);
  console.log('🔧 Is Render deployment:', CONFIG.IS_RENDER_DEPLOYMENT);
  console.log('🔧 Is Localhost:', CONFIG.IS_LOCALHOST);
  console.log('📦 Environment:', CONFIG.IS_PRODUCTION ? 'PRODUCTION' : 'DEVELOPMENT');
  console.log('🔍 Debug Level:', CONFIG.DEBUG_LEVEL);
  
  // Additional debugging for CORS issues
  if (CONFIG.IS_VERCEL_DEPLOYMENT) {
    console.log('🔍 CORS Debug Info:');
    console.log('  - Current domain:', window.location.hostname);
    console.log('  - API base URL:', CONFIG.API_BASE_URL);
    console.log('  - Expected CORS origin:', window.location.origin);
  }
}

export default CONFIG;